import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Card, Table, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class Consent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            data: [],
            showPdf: false,
        }
    }

    componentDidMount() {
        this.getFiles();
    }

    getFiles = () => {

        let dataSend = {
            id_historia: parseInt(this.props.id_historia),
            id_admision: 0
        };

        console.log(dataSend);
        fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                //console.log(data.contenido[0].archivos);
                this.createDatateble(data.contenido);

            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    createDatateble = (data) => {

        let filterData = [];

        for (let i = 0; i < data.length; i++) {

            if (data[i].archivos !== null) {

                for (let j = 0; j < data[i].archivos.archivos.length; j++) {

                    filterData.push(data[i].archivos.archivos[j]);
                }
            }
        }

        this.setData(filterData);
    }

    setData = (data) => {

        let filterData = [];

        let index = 0, cont = 0;

        while (cont < data.length) {

            if (data[cont].clase === "1") {

                filterData[index] = {
                    fecha: data[cont].fecha,
                    hora: data[cont].hora,
                    nombre: data[cont].fileName,
                    descripcion: data[cont].descripcion,
                    ruta: data[cont].ruta
                };
                index++;
                cont++;

            } else {
                cont++;
            }
        }
        console.log(filterData);
        this.setState({ data: filterData });

    }

    uploadFile = () => {

        const user = JSON.parse(sessionStorage.getItem('usuario'));

        var dataFile = new FormData();
        dataFile.append("archivo_consentimiento", this.state.file);
        dataFile.append("id_historia", parseInt(this.props.id_historia));
        dataFile.append("id_admision", parseInt(this.props.id_admision));
        dataFile.append("id_estudio", parseInt(this.props.id_estudio));
        dataFile.append("descripcion", "Consentimiento informado");
        dataFile.append("fecha", moment(new Date()).format("YYYY/MM/DD"));
        dataFile.append("hora", moment(new Date()).format("HH:MM A"));
        dataFile.append("usuario", user.usuario);

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-estudio/save-consentimiento', {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataFile
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                console.log(data);
                alert("archivo Subido Correctamente");
            }).catch((error) => {
                console.error('Error:', error);
            });
    }

    render() {

        return (
            <Col>
                <Card body outline color="secondary">
                    <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                        <div className="card__title">
                            <h5 className="bold-text">Consentimiento Informado</h5>
                        </div>

                        <div style={{ display: 'flex', marginTop: 40, }}>
                            <div style={{ marginRight: 20 }} >
                                <span className="form__form-group-label">Consentimiento Informado</span>
                            </div>
                            <div className="form__form-group-field">
                                <Field
                                    name="textarea-desc"
                                    component="textarea"
                                    type="text"
                                    style={{ width: '90%' }}
                                    //value={this.props.PhysicalExam.skin_appendages}
                                    onChange={(e) => {

                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: 20, marginLeft: 150 }}>
                            <input
                                type="file"
                                style={{ width: '30%', }}
                                onChange={(e) => {
                                    //console.log(e.target.files[0]);
                                    this.setState({ file: e.target.files[0] });
                                }}
                            />
                            <Button
                                style={{ marginLeft: 60, marginTop: 20 }}
                                size="sm"
                                color="primary"
                                onClick={() => {
                                    this.uploadFile();
                                }}
                            >Confirmar Documento
                            </Button>
                        </div>
                    </div>
                    <Table bordered style={{ width: '80%', marginTop: 20, marginLeft: 50 }}>
                        <thead>
                            <tr>
                                <td>Clase de Documento </td>
                                <td >Fecha </td>
                                <td >Nombre </td>
                                <td >Abrir Archivo </td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((data, index) => {

                                return <tr key={index}>
                                    <td>Consentimiento Informado</td>
                                    <td>{data.fecha}</td>
                                    <td>{data.nombre}</td>
                                    <td><Button
                                        outline
                                        onClick={() => {
                                            //window.open(process.env.REACT_APP_PUBLIC_URL + data.ruta + sessionStorage.getItem('token'), '_blank');
                                            this.setState({ showPdf: true });
                                        }}
                                    >
                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                    </Button>
                                        {this.state.showPdf ?
                                            <Modal
                                                open={this.state.showPdf}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                                style={{ zIndex: 1000 }}
                                            >
                                                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                                    <IconButton style={{ float: 'right' }} onClick={() => {
                                                        this.setState({ showPdf: false });
                                                    }}>
                                                        <CloseIcon />
                                                    </IconButton>

                                                    <iframe id="pdfV" width="1000" height="700" src={process.env.REACT_APP_PUBLIC_URL + data.ruta + sessionStorage.getItem('token')} >
                                                    </iframe>
                                                </div>
                                            </Modal>
                                            : null}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>


                </Card>
            </Col>
        );
    }

}
export default reduxForm({
    form: `consent-form`, // a unique identifier for this form
})(withTranslation('common')(Consent));